import $ from 'jquery'
import FilterDropdowns from './filter-dropdown'

// TODO: Read the contants from data-attributes
const INDUSTRIES_VALUES_KEY = 'industries'
const REGIONS_VALUES_KEY = 'regions'
const SORT_VALUES_KEY = 'sortBy'
const CITY_VALUES_KEY = 'city'

const SORT_DEFAULT_VALUE = 'alphabetical'

class HelpingHands {
  constructor(selector = '.helpinghands') {
    this.el = $(selector)
    this.filterResetTriggers = $('.helpinghands__filter-reset, .filterdropdown__reset', this.el)
    this.filterDropdowns = null

    this.filters = {}
    this.init()
  }

  init() {
    this.initFilterState()
    this.initFilterDropdowns()
    this.initFilterResetTriggers()
    this.initFilterCheckboxInputs()
  }

  initFilterState() {
    this.filters = {
      industries: {
        inputs: $('input[type=checkbox][name*=' + INDUSTRIES_VALUES_KEY + ']', this.el),
        active: false,
        default: null,
      },
      regions: {
        inputs: $('input[type=checkbox][name*=' + REGIONS_VALUES_KEY + ']', this.el),
        active: false,
        default: null,
      },
      sortBy: {
        inputs: $('input[type=radio][name*=' + SORT_VALUES_KEY + ']', this.el),
        active: false,
        default: SORT_DEFAULT_VALUE,
      },
      city: {
        inputs: $('input[type=text][name*=' + CITY_VALUES_KEY + ']', this.el),
        active: false,
        default: '',
      },
      active: false,
    }
    // Fil the indiviually determined active state
    this.filters.industries.active = this.filters.industries.inputs
      .toArray()
      .some(checkbox => checkbox.checked)
    this.filters.regions.active = this.filters.regions.inputs
      .toArray()
      .some(checkbox => checkbox.checked)
    this.filters.city.active = this.filters.city.inputs
      .toArray()
      .some(input => Boolean(input.value.length))
    this.filters.sortBy.active = this.filters.sortBy.inputs
      .toArray()
      .some(checkbox => checkbox.checked && checkbox.value !== SORT_DEFAULT_VALUE)
    this.filters.active =
      this.filters.industries.active ||
      this.filters.regions.active ||
      this.filters.city.active ||
      this.filters.sortBy.active
  }

  initFilterDropdowns() {
    this.filterDropdowns = new FilterDropdowns()
  }

  initFilterResetTriggers() {
    // If there are no active filters
    if (!this.filters.active) {
      return
    }

    // Show all global & local reset triggers based on their relation to filters
    this.filterResetTriggers.each((index, trigger) => {
      const $trigger = $(trigger)
      const filter = this.filters[$trigger.data('reset')]

      if (filter) {
        // show if related filter has an active state
        return filter.active ? $trigger.show() : true
      }
      // global reset triggers always shown
      $trigger.show()
    })
    // listen to reset clicks
    this.filterResetTriggers.on('click', this.onFilterReset.bind(this))
  }

  initFilterCheckboxInputs() {
    ;[INDUSTRIES_VALUES_KEY, REGIONS_VALUES_KEY, SORT_VALUES_KEY].forEach(key => {
      this.filters[key].inputs.on('change', this.onFilterCheckboxChanged.bind(this))
    })
  }

  onFilterReset(event) {
    event.preventDefault()
    const trigger = $(event.target)
    const key = trigger.data('reset')

    // Wether reset by key or all filters
    if (key) {
      // Reset specific filters and send the form
      this.resetFiltersByKey(key)
    } else {
      // Reset the whole form
      this.resetFilters()
    }

    // And finally submit the form
    this.submitForm(event.target)
  }

  onFilterCheckboxChanged(event) {
    this.submitForm(event.target)
  }

  resetFilters() {
    // reset all checkbox radio filters
    this.resetFiltersByKey(INDUSTRIES_VALUES_KEY)
    this.resetFiltersByKey(REGIONS_VALUES_KEY)
    this.resetFiltersByKey(SORT_VALUES_KEY)
    // reset city inputs
    this.filters.city.inputs.val('')
  }

  resetFiltersByKey(key) {
    //! Can only reset CHECKBOX || RADIO based filters (CITY filter input is type text)
    const filter = this.filters[key]

    if (!filter) {
      return
    }

    filter.inputs.each((index, checkbox) => {
      checkbox.value === filter.default ? (checkbox.checked = true) : (checkbox.checked = false)
    })
  }

  submitForm(trigger) {
    // look for the closest form and submit it
    $(trigger)
      .closest('form')
      .trigger('submit')
  }
}

export default HelpingHands
